import { Link, LinkProps } from "react-router-dom";
import { CSSProperties } from "react";
import { usePalette } from "@/shared/theme";

export function FooterLink(props: LinkProps) {
  const palette = usePalette();

  return (
    <Link
      className={"underline text-[--color]"}
      style={
        {
          "--color": palette.primary[5],
        } as CSSProperties
      }
      {...props}
    />
  );
}
